module.exports = __webpack_public_path__ + "img/export.b9dba2e3.svg";